<template>
  <section class="customcheckerboard-color-selector">
    <div :class="[
      'customcheckerboard-color-selector-body',
      'customcheckerboard-main-views-wrapper-body'
    ]"
    ref="checkerboardFabricCanvasContainer">
      <h5 :class="[
        'customcheckerboard-color-selector-title',
        'text-center',
        'customcheckerboard-main-views-wrapper-title',
      ]">{{ title }}</h5>
      <checkerboard-fabric-canvas
        v-if="dataLoaded"
        :tileConfig="tileConfig"
        :animateTiles="currentSelectedColor"
        :animateUsingColor="animateUsingColor"
        :color1="color1"
        :color2="color2"
        :activeColorSelection="true"
        @input="newColorSelected => updateCurrentSelectedColorKey(newColorSelected)"
        @canvasLoaded="canvasLoaded"
      ></checkerboard-fabric-canvas>
    </div>
    <div class="customcheckerboard-color-selector-buttons">
      <div class="customcheckerboard-color-selector-buttons-container">
        <button
          :class="[
            'customcheckerboard-color-selector-button', {
            'customcheckerboard-color-selector-button-active': currentSelectedColor === 'color1'
          }]"
          @click="updateCurrentSelectedColorKey('color1')"
        >{{  translations.customCheckerboardColor1 }}</button>
        <button
          :class="[
            'customcheckerboard-color-selector-button', {
            'customcheckerboard-color-selector-button-active': currentSelectedColor === 'color2'
          }]"
          @click="updateCurrentSelectedColorKey('color2')"
        >{{ translations.customCheckerboardColor2 }}</button>
      </div>
    </div>
    <checkerboard-color-control
      :isMainApp="isMainApp"
      :value="currentSelectedColorValue"
      @input="newColor => setCurrentSelectedColor(newColor)"
    ></checkerboard-color-control>
  </section>
</template>

<script>
import checkerboardFabricCanvas from "../../FabricCanvas/CheckerboardFabricCanvas";
import checkerboardColorControl from "./ColorControl/CheckerboardColorControl";
const commonSettings = {
  width: 55,
  height: 55,
  columns: 5,
  rows: 6,
};

export default {
  name: "checkerboardColorSelector",
  components: {
    checkerboardFabricCanvas,
    checkerboardColorControl
  },
  data() {
    return {
      colorSelectionSize: {
        desktop: {
          ...commonSettings,
          rows: 5,
        },
        mobile: {
          ...commonSettings,
          width: 45,
          height: 45,
        },
        mobileSmallVertical: {
          ...commonSettings,
          width: 35,
          height: 35,
        },
      },
      animateUsingColor: 'red',
      currentSelectedColor: 'color1',
      dataLoaded: null
    }
  },
  props: {
    isMainApp: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    translations(){
      return this.$store.state.translations.data;
    },
    screenSize() {
      return this.$store.getters["utils/returnScreenSize"];
    },
    isMobile() {
      return this.$store.getters["utils/returnScreenSize"].includes('mobile');
    },
    tileConfig() {
      const mediumVerticalBreakpoint = 620;
      const viewportHeight = window.innerHeight;
      let device = this.screenSize.includes('mobile') ? 'mobile' : 'desktop';
      if (device === 'mobile' && viewportHeight < mediumVerticalBreakpoint) {
        device = 'mobileSmallVertical';
      }
      const tileConfig = this.colorSelectionSize[device] || this.colorSelectionSize.desktop;
      const offsetHeight = this.$refs.checkerboardFabricCanvasContainer.offsetHeight;
      let { width, height } = tileConfig;

      if (this.isMainApp && !this.isMobile) {
        const responsiveSquare = (offsetHeight * 15 / 100);
        width = responsiveSquare
        height = responsiveSquare
      }

      return {
        ...tileConfig,
        width,
        height
      }
    },
    currentSelectedColorValue() {
      return this[this.currentSelectedColor];
    },
    title() {
      return this.currentSelectedColor === 'color1' ?
        this.translations.customCheckerboardColorStep1 :
        this.translations.customCheckerboardColorStep2;
    },
    color1() {
      return this.$store.state.customCheckerboard.canvasConfig.color1;
    },
    color2() {
      return this.$store.state.customCheckerboard.canvasConfig.color2;
    }
  },
  mounted() {
    this.dataLoaded = true;
  },
  methods: {
    updateCurrentSelectedColorKey(currentSelectedColor) {
      this.currentSelectedColor = currentSelectedColor;
      this.$eventBus.$emit('customcheckerboard-change-selected-color', currentSelectedColor);
      if (this.$store.getters['utils/useEcomDataLayerFormat']) {
        this.$checkerboardDataLayer.logAnalyticsEvent({
          action: 'Select Color Tab', eventLabel: `Color #${ currentSelectedColor.split('').pop()  }`
        });
      }
    },
    setCurrentSelectedColor(newColor) {
      this.$store.commit("customCheckerboard/SET_CANVAS_CONFIG", {
        [this.currentSelectedColor]: newColor,
      });
    },
    canvasLoaded() {
      this.$store.commit("customCheckerboard/SET_ENABLE_CONTROLS", true);
    }
  }
};
</script>
